import _ from "lodash";

/**
 * Adds payload entries to the cache,
 * uses the same entries' references to reduce memory consumption
 * @param cache - cache object
 * @param payload - payload entries
 * @returns payload entries linked to the cached ones
 */
export const withCache = <T extends { id: string }>(
    cache: { [id: string]: T },
    payload: { [id: string]: Array<T> }
) => {
    _.merge(cache, _.keyBy(_.flatMap(payload), "id"));
    return _.mapValues(payload, (list) => _.map(list, (elem) => cache[elem.id]));
};
